export enum Mode {
  Edit,
  Add,
  List,
}
